import { calculateAmount, IAmountCalculateParams } from './amount';
export {
    calculateAmount,
    IAmountCalculateParams
}